
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ConfigurationStore, UserStore } from '@/store/modules';
import { SendUserEmail } from '@/store/models/configuration';

@Component({
  meta: {
    title: 'Send Email'
  },
  components: {
    QvInput,
    QvSelect,
    ValidationProvider,
    ValidationObserver,
    LocationInputMap
  }
})
export default class SendEmail extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get categories() {
    return UserStore.Roles;
  }
  get userDetail() {
    return UserStore.UserDetail;
  }

  email: SendUserEmail = {} as SendUserEmail;
  allCategory: boolean | null = false;

  userId: number | null = null;

  async onSubmit() {
    if (this.email.email) {
      this.email.email = this.email.email.toLowerCase();
    }
    await ConfigurationStore.sendUserEmail(this.email);
    this.$q.notify({
      type: 'positive',
      message: `Email sent`,
      caption: `Email sent to ${this.email.email}.`
    });
  }
  onReset() {
    // eslint-disable-next-line
    this.email = {} as SendUserEmail;
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }

  async created() {
    const userId = this.$route.params.userId;
    if (userId) {
      this.userId = Number(userId);
      await UserStore.getUserDetailById(this.userId);
      const email = {} as SendUserEmail;
      email.toUser = this.userDetail.id;
      email.email = this.userDetail.email;
      let username = this.userDetail.fullName;
      if (!username || username == '') {
        username = this.userDetail.username;
      }
      email.toUsername = username;
      this.email = email;
    }
    UserStore.getUserRoles();
  }
}
